import axios from "axios";
import { NETWORK_CALL_FAILED, RewardsAccountsResponseV1 } from "redmond";

import { config } from "../../config";
import { trackEvent } from "../trackEvent";
import { rewardsApiPrefixV1 } from "../../paths";

const END_POINT: string = `${rewardsApiPrefixV1}/accounts`;

export const fetchRewardsAccountsV1 = (
  includeVcn?: boolean
): Promise<RewardsAccountsResponseV1> =>
  new Promise(async (resolve, reject) => {
    try {
      const res = await axios.put(
        END_POINT,
        {},
        {
          baseURL: config.baseURL,
          params: includeVcn ? { include: "VCN" } : undefined,
        }
      );
      resolve(res.data);
    } catch (e) {
      trackEvent({
        eventName: NETWORK_CALL_FAILED,
        properties: {
          url: window.location.pathname,
        },
      });
      reject(e);
    }
  });
